import { api } from '../services/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchGalleryItems = createAsyncThunk(
    'gallery/fetchGalleryItems',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/gallery');
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to fetch gallery items');
        }
    }
);

const gallerySlice = createSlice({
    name: 'gallery',
    initialState: {
        items: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGalleryItems.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchGalleryItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
            })
            .addCase(fetchGalleryItems.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const selectGalleryItems = (state) => state.gallery.items;
export const selectGalleryStatus = (state) => state.gallery.status;
export const selectGalleryError = (state) => state.gallery.error;

export default gallerySlice.reducer;
